import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 62006FDB-1540-4E32-B74D-A758C8974661
 * name order-bool-descending
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/order-bool-descending.svg
 * tags
 * - Text / Content / Format 
 */
export const OrderBoolDescendingIcon = createSvgIcon(<><path d="M6 13C3.79 13 2 14.79 2 17S3.79 21 6 21 10 19.21 10 17 8.21 13 6 13M6 19C4.9 19 4 18.1 4 17S4.9 15 6 15 8 15.9 8 17 7.1 19 6 19M6 3C3.79 3 2 4.79 2 7S3.79 11 6 11 10 9.21 10 7 8.21 3 6 3M12 5H22V7H12V5M12 19V17H22V19H12M12 11H22V13H12V11Z" /></>, 'OrderBoolDescendingIcon');
export default OrderBoolDescendingIcon